<template>
    <NuxtPage :transition="pageTransition" />
    <SnackbarPortal />
</template>

<script setup lang="ts">
    import { SnackbarPortal, useSnackbar } from '@tapp.online/ui'

    // out-in: the leaving page finishes before the next one enters, so the two never overlap.
    // No appear: the first page is already painted by the server, fading it in again on hydration would flash.
    const pageTransition = {
        mode: 'out-in' as const,
        enterActiveClass: 'transition-opacity duration-200 ease-out',
        enterFromClass: 'opacity-0',
        enterToClass: 'opacity-100',
        leaveActiveClass: 'transition-opacity duration-150 ease-in',
        leaveFromClass: 'opacity-100',
        leaveToClass: 'opacity-0'
    }

    const snackbar = useSnackbar()
    provide('snackbar', snackbar)
    snackbar.setSnackbarConfig({
        reverse: false,
        duration: 2000,
        maxSnackbars: 5,
        closeOnClick: true,
        pauseOnHover: true
    })
</script>
